import { render, staticRenderFns } from "./CustomThemePopup.vue?vue&type=template&id=5224c7fe&scoped=true"
import script from "./CustomThemePopup.vue?vue&type=script&lang=js"
export * from "./CustomThemePopup.vue?vue&type=script&lang=js"
import style0 from "./CustomThemePopup.vue?vue&type=style&index=0&id=5224c7fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224c7fe",
  null
  
)

export default component.exports